import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";

// Fix default marker icon (broken with bundlers)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const corailIcon = L.divIcon({
  className: "",
  html: `<div class="lbm-port-marker"></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  popupAnchor: [0, -28],
});

export default function MapView({ ports = [], trips = [], onPortClick, height = 460 }) {
  useEffect(() => {
    // ensure leaflet repaints if container resized
    window.dispatchEvent(new Event("resize"));
  }, []);

  return (
    <div
      data-testid="map-view"
      className="rounded-3xl overflow-hidden shadow-matelot border border-brume"
      style={{ height }}
    >
      <MapContainer center={[48.7, -2.8]} zoom={10} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {ports.map((p) => {
          const portTrips = trips.filter((t) => t.port === p.name);
          return (
            <Marker key={p.id} position={[p.lat, p.lng]} icon={corailIcon}
              eventHandlers={{ click: () => onPortClick?.(p) }}>
              <Popup>
                <div className="font-sans">
                  <div className="font-bold text-ocean text-base">{p.name}</div>
                  <div className="text-xs text-bretagne mb-2">{p.city}</div>
                  <div className="text-sm">
                    {portTrips.length > 0
                      ? `${portTrips.length} sortie${portTrips.length > 1 ? "s" : ""} disponible${portTrips.length > 1 ? "s" : ""}`
                      : "Aucune sortie pour le moment"}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
}
